export default "__VITE_ASSET__ce2af889__"